<template>
  <div class="bin-supply">
    <el-dialog
      title="更换商家子账户"
      :visible="visible"
      :before-close="closeBox"
    >
      <el-form :model="form" label-width="100px">
        <el-form-item label="姓名:" prop="name" required>
          <el-input v-model="form.name" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号:" prop="idcard" required>
          <el-input v-model="form.idcard" placeholder="身份证号"></el-input>
        </el-form-item>
        <el-form-item label="开户银行:" required>
          <el-select v-model="form.bank_name" filterable placeholder="开户银行">
            <el-option
              v-for="(item, index) in banks"
              :key="index"
              :label="index"
              :value="index"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="银行账号:" prop="card_no" required>
          <el-input v-model="form.card_no" placeholder="银行账号"></el-input>
        </el-form-item>
        <el-form-item label="手机号码:" prop="mobile" required>
          <el-input
            v-model="form.mobile"
            placeholder="手机号码"
            style="width: 85%"
          ></el-input>
          <el-button
            v-show="show"
            type="primary"
            style="float: right"
            @click="sendSms"
            >发送验证码</el-button
          >
          <el-button v-show="!show" class="count" disabled>
            {{ count }} s</el-button
          >
        </el-form-item>
        <el-form-item label="短信验证码:" prop="code" required>
          <el-input v-model="form.code" placeholder="短信验证码"></el-input>
        </el-form-item>

        <el-form-item label=" ">
          <el-button style="width: 25%" @click="closeBox(0)">取消</el-button>
          <el-button type="success" style="width: 25%" @click="submitData">
            确认更换</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
const TIME_COUNT = 60;

export default {
  name: "ChangeAcctInfo",
  props: {
    supplyId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      visible: true,
      form: {},
      banks: [],
      show: true,
      timer: null,
      count: "",
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    sendSms() {
      this.form.supply_id = this.supplyId;
      this.$http
        .post("/erp/Supply/bindCardGetSms", this.form)
        .then((result) => {
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
            return;
          }
          this.$message.success(result.data.msg);
          this.timecount();
        })
        .catch(() => {});
    },
    fetchData() {
      this.$http
        .post("/erp/Supply/getBanks", this.form)
        .then((result) => {
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
            return;
          }
          this.banks = result.data.data.banks;
        })
        .catch(() => {});
    },
    timecount() {
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count -= 1;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    submitData() {
      this.form.supply_id = this.supplyId;
      this.$http
        .post("/erp/Supply/bindCardSmsRe", this.form)
        .then((result) => {
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
            return;
          }
          this.$message.success("修改成功");
          this.closeBox(true);
        })
        .catch(() => {});
    },
    closeBox(isNormal) {
      let _isNormal = isNormal;
      if (typeof isNormal === "function") {
        _isNormal = 0;
      }
      this.$emit("onCloseDialog", _isNormal);
    },
  },
};
</script>

<style>
.bind-supply .el-dialog {
  width: 25% !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/components/ChangeAcctInfo.vue